import { put, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import _local from 'utils/localStorageUtils';

import {
  CHANGE_CHECKUSEREMAIL,
} from './constants';

import {
  changeCheckUserEmailError,
  changeCheckUserEmailSuccess,
} from './actions';


export function* changeCheckUserEmail(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { checkUserEmailData } = action;

    const changedCheckUserEmail = yield requestWrapper(
        'POST',
        'auth/email/',
        checkUserEmailData,
        currentUser.token,
      );

    if (!changedCheckUserEmail) {
      yield put(changeCheckUserEmailSuccess(false));
    } else {
      yield put(changeCheckUserEmailSuccess(changedCheckUserEmail));
    }
  } catch (error) {
    yield put(changeCheckUserEmailError(error));
  }
}

export default function* checkUserEmailSaga() {
  yield takeLatest(CHANGE_CHECKUSEREMAIL, changeCheckUserEmail);
}
